import React from 'react';
/* import { Container, Row, Col } from 'react-bootstrap';

import HeaderSection from '../components/HeaderSection';
import TopSimpleSection from '../components/TopSimpleSection'; */
import TopMenu from '../components/Navbar/Navbar';
/* import SimpleSection from '../components/SimpleSection';
import Footer from '../components/Footer';
import WBkey from '../components/WBkey';
import Subscribe from '../components/Subscribe'; */
import ItemHeader from '../components/ItemHeader';
import Footer from '../components/Footer/Footer';
import Back2TopBtn from '../components/Back2TopBtn';

/* document.addEventListener('DOMContentLoaded', function () {
	window.addEventListener('scroll', function () {
		let navbar_height =
			document.getElementById('c-top-navbar').offsetHeight;
		if (window.scrollY > navbar_height + 50) {
			document.getElementById('c-top-navbar').classList.add('fixed-top');
			document.getElementById('c-nav-bar-fixer').style.height =
				navbar_height + 'px';
		} else {
			document
				.getElementById('c-top-navbar')
				.classList.remove('fixed-top');
			document.getElementById('c-nav-bar-fixer').style.height = 'auto';
		}
	});
}); */

export default function AboutLayout(props) {
	const {
		children,
		IsadgData,
	} = props;
	return (
		<div className='c-main-wrapper c-ilay'>
			<TopMenu background='white' />
			<ItemHeader IsadgData={IsadgData} />

			{children}
			<Back2TopBtn/>
			<Footer />
			{/* <div className='pfoot'>{/*Pseudofooter* /}</div> */}
		</div>
	);
}
